export enum UserRolesEnum {
  Admin = '25e102f4-7ee1-4fca-9071-f16e03da237b',
	SubAdmin = 'dc3210b5-57ec-44db-bca6-8fce8ed76633',
  User = '12c57649-f88c-4c97-9a75-3e5ffef1b9d6',
}
